<div class="main-content">
  <div class="container-fluid">

      <div class="clearfix"></div>
      <div class="row">
          <div class="col-md-12">

              <div class="card">

                  <div class="card-header card/-header-primary card-header-icon">
                      <div class="card-icon">
                          <i class="material-icons">inventory</i>
                      </div>
                      <h4 class="card-title">My archived folders</h4>
                  </div>

                  <div class="card-body">

                    <div class="row">
                      <div class="col-md-12" style="text-align: right;">
                        <button class="btn btn-outline-secondary" (click)="unarchive()" [disabled]="bulk.length === 0">
                          <span class="material-icons">unarchive</span> &nbsp; Unarchive
                        </button>
                      </div>
                    </div>

                      <div *ngIf="loading" class="row" style="text-align: center">
                          <div class="col-12">
                            <h2><b><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i> Loading...</b></h2>
                          </div>
                      </div>

                      <dinamic-table
                        *ngIf="!loading"
                        [id]="'archiveTable'"
                        [frontpaginate]="true"
                        [data]="data"
                        [dateColums]="[4]"
                        [bulk]="bulk"
                        (action_button)="action($event)"
                      ></dinamic-table>

                      <br><br>

                      <button class="btn btn-default btn-md" [routerLink]="['/tables/listfiles']">
                        <i class="fa fa-reply" aria-hidden="true"></i> &nbsp; Back
                      </button>

                  </div>

              </div>

          </div>
      </div>

  </div>
</div>